export const SET_QUIZ = 'ROOM/QUIZ/SET_QUIZ'
export const SET_QUIZZES = 'ROOM/QUIZ/SET_QUIZZES'
